// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__5HJkP","messages":"Chat_messages__1l1D5","dateDivider":"Chat_dateDivider__2jtKg"};